module.exports = __webpack_public_path__ + "media/images/sp/stores/kyoto/main-visual-text-92bf6cb467d9f5c2cd13bc572753230b.png";